import { qualifySelector } from "../utils";
import {
  DOMAIN_SEARCH_RESET_CACHE,
  DOMAIN_BY_TYPE_SUCCESS,
  DOMAIN_BY_TYPE_REQUEST,
  DOMAIN_BY_TYPE_FAILURE,
  NEXT_PAGE_FAILURE,
  NEXT_PAGE_SUCCESS,
  NEXT_PAGE_REQUEST,
  BUNDLE_SEARCH_FAILURE,
  BUNDLE_SEARCH_SUCCESS,
  BUNDLE_SEARCH_REQUEST,
} from "../constants";

import domain from "../models/domain";
import bundle from "../models/bundle";

const initialState = {
  domainsLoaded: false,
  domainsErrored: false,
  domainsLoading: false,
  bundlesLoaded: false,
  bundlesErrored: false,
  bundlesLoading: false,
  nextPageLoading: false,
  keyword: window.localStorage.getItem("keyword"),

  filteredDomains: [],
  all: [],
  pagination: {},
  defaultIncludeVat: false,
  decimalSeparator: ",",
  domainsLoadedTimestamp: 0,
  bundle: [],
  currency: "",
  monthlyPrices: false,
};

function reducer(state = initialState, action) {
  const { payload, type } = action;
  if (type === DOMAIN_BY_TYPE_REQUEST) {
    return {
      ...state,
      domainsLoaded: false,
      domainsErrored: false,
      domainsLoading: true,
    };
  }

  if (type === BUNDLE_SEARCH_REQUEST) {
    return {
      ...state,
      bundlesLoaded: false,
      bundlesErrored: false,
      bundlesLoading: true,
    };
  }

  if (type === NEXT_PAGE_REQUEST) {
    return {
      ...state,
      domainsLoaded: false,
      domainsErrored: false,
      nextPageLoading: true,
    };
  }

  if (type === BUNDLE_SEARCH_SUCCESS) {
    const {
      bundles,
      keyword,
      currency,
      defaultIncludeVat,
      decimalSeparator,
      monthlyPrices,
    } = payload;

    // Bundle
    const newBundles = bundles.map((entry) =>
      bundle(entry, defaultIncludeVat, decimalSeparator),
    );

    return {
      ...state,

      // Loading flags
      bundlesLoaded: true,
      bundlesErrored: false,
      bundlesLoading: false,
      keyword: keyword,
      bundle: [...newBundles],

      // misc
      currency: currency,
      monthlyPrices: monthlyPrices,
    };
  }

  if (type === NEXT_PAGE_SUCCESS) {
    const {
      domains,
      keyword,
      currency,
      type,
      pagination,
      defaultIncludeVat,
      decimalSeparator,
    } = payload;

    const newDomains = domains.map((entry) => {
      return domain(entry, type, defaultIncludeVat, decimalSeparator);
    });

    return {
      ...state,
      domainsLoaded: true,
      domainsErrored: false,
      nextPageLoading: false,
      domainsLoadedTimestamp: Date.now(),
      all: [...state.all, ...newDomains],
      pagination,
      currency,
      keyword,
    };
  }

  if (type === DOMAIN_BY_TYPE_SUCCESS) {
    const {
      domains,
      keyword,
      currency,
      type,
      pagination,
      defaultIncludeVat,
      decimalSeparator,
    } = payload;

    let category = "filteredDomains";
    let newDomains = domains.map((entry) => {
      return domain(entry, type, defaultIncludeVat, decimalSeparator);
    });

    if (type === "all") {
      category = "all";
      newDomains = [...state.all, ...newDomains];
    }

    return {
      ...state,
      domainsLoaded: true,
      domainsErrored: false,
      domainsLoading: false,
      domainsLoadedTimestamp: Date.now(),
      [category]: newDomains,
      pagination,
      currency,
      keyword,
    };
  }

  if (type === DOMAIN_SEARCH_RESET_CACHE) {
    return {
      ...state,
      filteredDomains: [],
      all: [],
    };
  }

  if (type === DOMAIN_BY_TYPE_FAILURE || type === NEXT_PAGE_FAILURE) {
    return {
      ...state,
      domainsLoaded: false,
      domainsErrored: true,
      domainsLoading: false,
      nextPageLoading: false,
    };
  }

  if (type === BUNDLE_SEARCH_FAILURE) {
    return {
      ...state,
      bundlesLoaded: false,
      bundlesErrored: true,
      bundlesLoading: false,
    };
  }

  return state;
}

export const name = "domains";
export default { [name]: reducer };
export const isDomainsLoading = qualifySelector(
  name,
  (state) => state.domainsLoading,
);
export const isDomainsLoaded = qualifySelector(
  name,
  (state) => state.domainsLoaded,
);
export const isDomainsErrored = qualifySelector(
  name,
  (state) => state.domainsErrored,
);
export const isNextPageLoading = qualifySelector(name, (state) => {
  return state.nextPageLoading;
});
export const getCurrency = qualifySelector(name, (state) => state.currency);
export const getMonthlyPrices = qualifySelector(
  name,
  (state) => state.monthlyPrices,
);
export const getBundle = qualifySelector(name, (state) => state.bundle);
export const getKeyword = qualifySelector(name, (state) => state.keyword);

export const getDomainsByType = qualifySelector(
  name,
  (state, type) => state[type],
);
export const getNextPage = qualifySelector(
  name,
  (state) => state.pagination.nextPage,
);

export const isBundlesLoading = qualifySelector(
  name,
  (state) => state.bundlesLoading,
);
export const isBundlesLoaded = qualifySelector(
  name,
  (state) => state.bundlesLoaded,
);
export const isDomainsTypePopular = qualifySelector(
  name,
  (state) =>
    state.filteredDomains.length > 0 &&
    state.filteredDomains[0].type === "popular",
);
export const isFreeWithHosting = qualifySelector(name, (state, tldWithDot) => {
  if (state.filteredDomains.length > 0) {
    return state.filteredDomains.some(
      ({ tld, rebateType }) =>
        tld === tldWithDot && rebateType === "FREE_WITH_HOSTING",
    );
  }
  return false;
});
